import { StyledCard } from "./Card.style";

export default StyledCard;
